import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import mapImg from "../../../images/map-left.jpg";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { getSelectedOption } from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { MAP_KEY, URLS } from "../../../_config";
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from "../../../store/selectors/masterSelector";
import { useChecklistApi } from "../../../store/api/hooks/checklistApiHook";
import { useNavigate } from "react-router-dom";

interface AssetsFormProps {
	_ref?: any;
	editData?: any;
	refChecklist?: any;
	onCreate?: () => void
	onCancel?: () => void
}

type ChecklistFormTypes = {
	name: string;
	description: string;
	typeID: Option;
	isWorkThrough: boolean;
};

const CreateChecklist: React.FC<AssetsFormProps> = ({ _ref, editData, refChecklist, onCreate = () => { }, onCancel = () => { } }) => {

	const { control, handleSubmit, setValue, reset, formState: { errors }, watch } = useForm<ChecklistFormTypes>({
		defaultValues: {
			isWorkThrough: false,
		}
	});
	const { showLoader, hideLoader } = useAppLoader();
	const [checklistCode, setChecklistCode] = useState<any>(null);
	const [facilityoption, setFacilityoption] = useState<any>([]);

	const [vendorlist, setvendorList] = useState<any>([]);
	const navigate = useNavigate();

	const [checklistTypes, setChecklistTypes] = useState<any>([]);

	const assetsCategories = useAssestCategoriesSelector();
	const assetsDepartments = useAssestDepartmentsSelector();
	const assetsGroups = useAssestGroupsSelector();
	const assetsSubGroups = useAssestSubGroupsSelector();
	const assetsTypes = useAssestTypesSelector();
	const assetsClassifications = useAssestClassificationsSelector();
	const assetsStatues = useAssestStatuesSelector();

	const defaultLatitude = 40.712776; // Example default latitude (New York)
	const defaultLongitude = -74.005974; // Example default longitude (New York)

	const assetApi: any = useAssetsApi();
	const facilityApi: any = useFacilitiesApi();
	const checklistAPI: any = useChecklistApi();


	useEffect(() => {
		if (assetsCategories == null) {
			assetApi.getAssetCategpry({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsCategories]);

	useEffect(() => {
		if (assetsDepartments == null) {
			assetApi.getAssetdepartment({pageSize: 5000,
                pageNumber: 1,}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsDepartments]);

	useEffect(() => {
		if (assetsGroups == null) {
			assetApi.getAssetGrouplist({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsGroups]);

	useEffect(() => {
		if (assetsSubGroups == null) {
			assetApi.getAssetSubGrouplist({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsSubGroups]);

	useEffect(() => {
		if (assetsTypes == null) {
			assetApi.GetAssetTypeList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsTypes]);

	useEffect(() => {
		if (assetsClassifications == null) {
			assetApi.GetAssetClassificationList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsClassifications]);

	useEffect(() => {
		if (assetsStatues == null) {
			assetApi.GetAssetStatusList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsStatues]);

	const getChecklistTypes = () => {
		const payload = {};
		checklistAPI.getChecklistTypes(
			payload,
			(resp: any) => {
				console.log("getChecklistTypes  =>", resp.checklistTypeList);
				let checklistTypes: any = [];

				resp?.checklistTypeList?.map((checklist: any) => {
					checklistTypes.push({
						label: checklist.checkListTypeName,
						value: checklist.checkListTypeID,
					});
				});
				console.log("checklistTypes =>", checklistTypes);
				setChecklistTypes(checklistTypes);
			},
			(error: any) => {
				console.log("error =>", error);
				//toast.error(error);
			}
		);
	};


	const getChecklistCode = () => {
		const payload = {};
		checklistAPI.getChecklistCode(
			payload,
			(resp: any) => {
				console.log("getChecklistCode  =>", resp.code);
				setChecklistCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				//toast.error(error);
			}
		);
	};

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				//toast.error(error);
			}
		);
	};


	const GetvenderList = () => {
		const payload = {};
		assetApi.GetvenderList(
			payload,
			(resp: any) => {
				let deptlist: any = [];

				resp.vendorList.map((facilist: any) => {
					deptlist.push({
						label: facilist.name,
						value: facilist.vendorID,
					});
				});
				setvendorList(deptlist);
			},
			(error: any) => {
				console.log("error =>", error);
				//toast.error(error);
			}
		);
	};



	const onSubmit: SubmitHandler<ChecklistFormTypes> = (data) => {
		console.log("onSubmit data", data);



		let payload: any = {
			"title": data.name,
			"checkListCode": checklistCode,
			"description": data.description,
			"checkListTypeID": data.typeID?.value,
			"isWorkThrough": data.isWorkThrough,
		}

		if (editData) {
			payload['checkListCode'] = editData.checkListCode;
			payload['checkListID'] = editData.checkListID;
		}
		showLoader();
		if (refChecklist) {
			payload['refCheckListID'] = refChecklist.checkListID;
			checklistAPI.duplicateChecklist(payload, (resp: any) => {
				const formData = new FormData();
				onCreate();
				onCancel();
				console.log(resp, "Submited resp")
				toast.success(resp?.message)
				formReset();
				hideLoader();
				getChecklistCode();

			}, (error: any) => {
				console.log('error =>', error);
				hideLoader();
				//toast.error(error);
			});
		} else {
			checklistAPI.saveChecklist({ objRequestModel: [payload] }, (resp: any) => {
				const formData = new FormData();
				onCreate();
				onCancel();
				console.log(resp, "Submited resp checklist")
				toast.success(resp?.message)
				formReset();
				hideLoader();
				getChecklistCode();
				navigate(URLS.CHECKLIST_CREATE(resp.returnID))

			}, (error: any) => {
				console.log('error =>', error);
				hideLoader();
				//toast.error(error);
			});
		}


	};

	useEffect(() => {
		getChecklistTypes();
		getChecklistCode();
		getfacilitylist();
		GetvenderList();
	}, []);



	const formReset = () => {
		reset({
			name: "",
			description: "",
			typeID: null,
			isWorkThrough: false,
		});

	}

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
			_ref.current.setValue = setValue;
		}
	}, [_ref])

	useEffect(() => {
		if (editData == null) {
			formReset();
		}
	}, [editData]);

	useEffect(() => {
		if (editData && checklistTypes?.length > 0) {
			reset({
				name: editData.title,
				description: editData.description,
				typeID: getSelectedOption(editData.checkListTypeID, checklistTypes),
				isWorkThrough: editData.isWorkThrough,
			});
		} else {
			formReset();
		}
	}, [editData, checklistTypes]);


	return (

		<form onSubmit={handleSubmit(onSubmit)} ref={_ref} className="flex flex-col h-full">
			<div className="flex-1 overflow-auto">


				<Controller
					name="name"
					control={control}
					rules={{ required: "Name Required" }}
					render={({ field: { value, onChange } }) => (
						<Input
							label="Name"
							type="text"
							value={value}
							onChange={onChange}
							required
							placeholder="Checklist Name"
							error={errors.name?.message}
						/>
					)}
				/>
				<Controller
					name="description"
					rules={{ required: "Description is required" }}
					control={control}
					render={({ field: { value, onChange } }) => (
						<Teaxtarea
							label="Description"
							value={value}
							onChange={onChange}
							required
							placeholder="Write Checklist description here"
							error={errors.description?.message}
						/>
					)}
				/>
				<Controller
					name="isWorkThrough"
					control={control}
					render={({ field: { value, onChange } }) => (
						<div className="flex items-center gap-2 my-3">
							<input type="checkbox" checked={value} onChange={onChange} />
							<p>This is a checklist for Walkthrough</p>
						</div>
					)}
				/>
				{/* <Controller
					name="typeID"
					control={control}
					rules={{ required: false }}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Type"
							value={value}
							onChange={onChange}
							placeholder="Choose Type"
							options={checklistTypes}
							error={errors.typeID?.message as any}
						/>
					)}
				/> */}

			</div>
			<div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
				<Button type="button" theme="secondary" onClick={() => {
					formReset();
					onCancel()
				}}>
					Cancel
				</Button>
				<Button type="submit" working={false}>
					Save
				</Button>
			</div>
		</form>
	);
};

export default CreateChecklist;
